import {
  Avatar,
  AvatarGroup,
  Button,
  Center,
  CenterProps,
  HStack,
  Image,
  Separator,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { DrawerIcon } from "./drawerIcon";
import Logo from "./assets/logo-novel.svg";
import UserPlaceholder from "./assets/user-placeholder.svg";

type User = {
  name: string;
  profileImageUrl: string | undefined;
};

type Props = {
  user: User | undefined;
  selectedPage?: "home" | "contest";
  onClickDrawer?: () => void;
  onClickWriteStory?: () => void;
} & CenterProps;

export const NavigationHeader = ({
  user,
  selectedPage,
  onClickDrawer,
  onClickWriteStory,
  ...centerProps
}: Props) => {
  return (
    <Center
      w="100%"
      h={{
        base: "48px",
        lg: "72px",
      }}
      bg="backgroundAbsolutely"
      borderBottomWidth={0.5}
      borderBottomColor="borderBorderPrimary"
      {...centerProps}
    >
      <HStack
        w="100%"
        maxW="1200px"
        px={{
          base: "3",
          lg: "20",
        }}
        justifyContent="space-between"
      >
        {/* Left Items */}
        <HStack
          gap={{
            base: "2",
            lg: "12",
          }}
        >
          <a href="/">
            <Image alt="Teller Novel" src={Logo} w="140px" />
          </a>

          <HStack display={{ base: "none", lg: "flex" }} gap="6">
            <Link to="/?notransition=1">
              <Button
                variant="plain"
                color="contentPrimary"
                fontSize={16}
                fontWeight={selectedPage === "home" ? "bold" : "normal"}
              >
                作品一覧
              </Button>
            </Link>

            <Separator
              orientation="vertical"
              h="24px"
              size="md"
              borderColor="borderBorderPrimary"
            />

            <Link to="/contests?notransition=1">
              <Button
                variant="plain"
                color="contentPrimary"
                fontSize={16}
                fontWeight={selectedPage === "contest" ? "bold" : "normal"}
              >
                コンテスト
              </Button>
            </Link>
          </HStack>
        </HStack>

        {/* Right Items */}
        <HStack
          gap={{
            base: "2",
            lg: "6",
          }}
        >
          <Button
            bg="backgroundLinkPrimary"
            variant="solid"
            borderRadius="full"
            display={{ base: "none", lg: "flex" }}
            px={6}
            color="white"
            fontWeight="bold"
            fontSize={16}
            onClick={onClickWriteStory}
          >
            <FaPlus color="white" /> 新しい作品を書く
          </Button>
          <ChakraLink href="/my_page">
            <AvatarGroup>
              <Avatar.Root width="32px" height="32px" bg="transparent">
                <Avatar.Image
                  src={user?.profileImageUrl || UserPlaceholder}
                  alt={user?.name}
                />
              </Avatar.Root>
            </AvatarGroup>
          </ChakraLink>

          <DrawerIcon cursor="pointer" onClick={onClickDrawer} />
        </HStack>
      </HStack>
    </Center>
  );
};
